import React, { useState, useCallback } from "react"
import moment from "moment"
import "moment/locale/ja"
import { graphql } from "gatsby"
import striptags from "striptags"
import scrollTo from "gatsby-plugin-smoothscroll"

import SEO from "../components/seo"
import Section from "../components/Section"
import Layout from "../components/layout"
import Button from "../components/Button"
import Markdown from "../components/Markdown"
import Tag from "../components/Tag"
import FormBox from "../components/FormBox"

import useUtmParams from "../hooks/useUtmParams"

import "./cms.scss"
import "./form.scss"
import "./event.scss"

interface Props {
  props?: any
  data?: any
  eventOpen?: boolean
}

const EventTemplete: React.FC<Props> = (props) => {
  const post = props.data.microcmsEvent
  const event = post.eventOpen

  const [Submitting, setSubmitting] = useState(false)
  const HandleSubmit = useCallback(() => {
    setSubmitting(true)
  }, []);
  const { utmSource, utmMedium, utmCampaign } = useUtmParams();
  return (
    <Layout>
      <div className="pharms-form">
        <div className="main">
          <div className="left">
            <h1 className="h1">{post.title}</h1>
            <div className="flex">
              {event ? <Tag>受付中</Tag> : <Tag color="gray">開催終了</Tag>}
              {post.date ? event && (
                <p>
                  開催日：{moment(`${post.date}`).format("YYYY年MM月DD日(ddd)")}
                </p>
              ) : null 
              }
            </div>
            {post.keyvisual ? (
              <img className="keyvisual" src={post.keyvisual.url} alt={`${post.title}画像`}/>
            ) : null}
            {event && post.pardotURL ? (
              <Button className="scroll-to-form" color="primary" onClick={() => scrollTo("#form")}>
                セミナーに参加する
              </Button>
            ) : null}
            <Markdown>
              <div dangerouslySetInnerHTML={{ __html: `${post.content}` }} />
            </Markdown>

            {post.iframe && (
              <div dangerouslySetInnerHTML={{ __html: `${post.iframe}` }} />
            )}

            {post.contents ? (
              <div
                className="pharms-form"
                dangerouslySetInnerHTML={{
                  __html: `${post.contents.map((contents) => contents.htmlTag)}`,
                }}
              />
            ) : null}
          </div>
          {post.pardotURL ? (
            <div className="right"id="form">
              <div className="card">
                <form action={post.pardotURL} method="POST" onSubmit={HandleSubmit}>
                <FormBox>
                  <input
                    type="hidden"
                    name="utmSource"
                    placeholder="例）google"
                    value={utmSource}
                    width={'100%'}
                  />
                  <input
                    type="hidden"
                    name="utmMedium"
                    placeholder="例）mail"
                    value={utmMedium}
                    width={'100%'}
                  />
                  <input
                    type="hidden"
                    name="utmCampaign"
                    placeholder="例）20240528"
                    value={utmCampaign}
                    width={'100%'}
                  />
                </FormBox>  
                  <FormBox>
                    <FormBox.Title>
                      <FormBox.Field>法人名</FormBox.Field>
                      <FormBox.Label required />
                    </FormBox.Title>
                    <FormBox.Contents>
                      <input
                        type="text"
                        name="companyName"
                        placeholder="株式会社メドレー"
                        required
                      />
                      <p className="form-error">法人名を入力してください</p>
                    </FormBox.Contents>
                  </FormBox>
                  {post.openRange == "全体公開" ? (
                    <>
                      <FormBox>
                        <FormBox.Title>
                          <FormBox.Field>薬局名</FormBox.Field>
                          <FormBox.Label required />
                        </FormBox.Title>
                        <FormBox.Contents>
                          <input
                            type="text"
                            name="storeName"
                            placeholder="ファームス薬局"
                            required
                          />
                          <p className="form-error">薬局名を入力してください</p>
                        </FormBox.Contents>
                      </FormBox>
                    </>
                  ) : null }
                  <FormBox>
                    <FormBox.Title>
                      <FormBox.Field>役職</FormBox.Field>
                      <FormBox.Label required />
                    </FormBox.Title>
                    <FormBox.Contents>
                      <select name="companyPosition" required>
                        <option value="">選択してください</option>
                        <option value="経営者">経営者</option>
                        <option value="役員">役員</option>
                        <option value="部門長（薬局長など）">部門長（薬局長など）</option>
                        <option value="本部担当者">本部担当者</option>
                        <option value="管理薬剤師">管理薬剤師</option>
                        <option value="現場薬剤師">現場薬剤師</option>
                        <option value="パートスタッフ">パートスタッフ</option>
                        <option value="その他">その他</option>
                      </select>
                      <p className="form-error">役職を選択してください</p>
                    </FormBox.Contents>
                  </FormBox>
                  <div className="form-names">
                    <FormBox>
                      <FormBox.Title>
                        <FormBox.Field>姓</FormBox.Field>
                        <FormBox.Label required />
                      </FormBox.Title>
                      <FormBox.Contents>
                        <input
                          type="text"
                          name="familyName"
                          placeholder="薬剤師"
                          required
                        />
                        <p className="form-error">姓を入力してください</p>
                      </FormBox.Contents>
                    </FormBox>
                    <FormBox>
                      <FormBox.Title>
                        <FormBox.Field>名</FormBox.Field>
                        <FormBox.Label required />
                      </FormBox.Title>
                      <FormBox.Contents>
                        <input
                          type="text"
                          name="givenName"
                          placeholder="太郎"
                          required
                        />
                        <p className="form-error">名を入力してください</p>
                      </FormBox.Contents>
                    </FormBox>
                  </div>
                  <FormBox>
                    <FormBox.Title>
                      <FormBox.Field>電話番号</FormBox.Field>
                      <FormBox.Label required />
                    </FormBox.Title>
                    <FormBox.Contents>
                      <input
                        type="tel"
                        name="tel"
                        placeholder="03-1234-5678"
                        required
                        pattern="[\d\-]*"
                        maxLength={13}
                      />
                      <p className="form-error">
                        電話番号を半角数字で入力してください
                      </p>
                    </FormBox.Contents>
                  </FormBox>
                  <FormBox>
                    <FormBox.Title>
                      <FormBox.Field>メールアドレス</FormBox.Field>
                      <FormBox.Label required />
                    </FormBox.Title>
                    <FormBox.Contents>
                      <input
                        type="email"
                        name="email"
                        placeholder="info@pharms-cloud.com"
                        required
                      />
                      <p className="form-error">
                        メールアドレスを入力してください
                      </p>
                    </FormBox.Contents>
                  </FormBox>

                  <div className="honeypot">
                        <FormBox>
                          <FormBox.Title>
                            <FormBox.Field>コメント</FormBox.Field>
                            <FormBox.Label />
                          </FormBox.Title>
                          <FormBox.Contents>
                            <input
                              type="text" 
                              id="pardot_extra_field" 
                              name="pardot_extra_field"
                            />
                          </FormBox.Contents>
                        </FormBox>
                        </div>

                  {post.openRange == "パートナー限定" ? (
                    <>
                      <FormBox>
                        <FormBox.Title>
                          <FormBox.Field>ご紹介代理店 企業名／支店名</FormBox.Field>
                          <FormBox.Label required />
                        </FormBox.Title>
                        <FormBox.Contents>
                          <input
                            type="text"
                            name="referrerCompany"
                            required
                          />
                          <p className="form-error">
                            ご紹介代理店 企業名／支店名を入力してください
                          </p>
                        </FormBox.Contents>
                      </FormBox>
                      <FormBox>
                        <FormBox.Title>
                          <FormBox.Field>ご紹介代理店 企業担当者名</FormBox.Field>
                          <FormBox.Label required />
                        </FormBox.Title>
                        <FormBox.Contents>
                          <input
                            type="text"
                            name="referrerPerson"
                            required
                          />
                          <p className="form-error">
                            ご紹介代理店 企業担当者名を入力してください
                          </p>
                        </FormBox.Contents>
                      </FormBox>
                    </>
                  ) : null }
                  
                  {post.privacy ? (
                    <>
                      <p className="text">
                        下記プライバシーポリシーに同意いただいた上で、送信ボタンを押してください
                      </p>
                      <div
                        className="privacy-link"
                        dangerouslySetInnerHTML={{ __html: `${post.privacy}` }}
                      />
                    </>
                  ) : (
                    <FormBox.Footer>
                      <p className="text pr">
                        「
                        <a
                          className="link"
                          href="https://www.medley.jp/contact/privacy.html"
                          target="_blank"
                        >
                          プライバシーポリシー
                        </a>
                        」に同意いただいた上で、送信ボタンを押してください
                      </p>
                    </FormBox.Footer>
                  )}
                  {Submitting ? (
                    <input type="submit" className="fill" value="送信中" disabled />
                  ) : (
                    <input type="submit" className="fill" value="送信" />
                  )}
                </form>
              </div>
            </div>
          ) : null}
        </div>

        <Section appearance="footer" padding="m">
          <Button href="/event/" use="back">
            セミナー・イベント一覧
          </Button>
        </Section>
      </div>
    </Layout>
  )
}

export default EventTemplete

export const Head = (props: Props) => (
  <SEO
    type="event"
    title={props.data.microcmsEvent.title}
    ogImage={props.data.microcmsEvent.keyvisual.url}
    description={summarize(props.data.microcmsEvent.content)}
    path={`/event/${props.data.microcmsEvent.eventId}`}
  >
    <meta charSet="utf-8" />
    <title>{props.data.microcmsEvent.title}</title>
  </SEO>
)

export const query = graphql`
  query($id: String!) {
    microcmsEvent(id: { eq: $id }) {
      id
      date
      title
      eventId
      content
      eventOpen
      pardotURL
      iframe
      privacy
      contents {
        htmlTag
      }
      keyvisual {
        url
      }
      openRange
    }
  }
`

function summarize(html: string) {
  const postContent = striptags(html).replace(/\r?\n/g, "").trim()
  return postContent.length <= 117
    ? postContent
    : postContent.slice(0, 117) + "..."
}
